import React from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '@btime/constants'
import Tag from '../../packages/kiti/components/presentation/Tag'
import Tooltip from '../../components/helpers/Tooltip'
import Text from '../../packages/kiti/components/presentation/Text'

const Content = ({ value, t }) => {
  if (!value)
    return (
      <Tag bgColor={'gray'} color={'gray'}>
        {t('statusTag.pending')}
      </Tag>
    )
  if (value === 'success') {
    return (
      <Tag bgColor={colors.green} color={colors.green}>
        {t('statusTag.success')}
      </Tag>
    )
  }

  if (value.includes('insufficient_amount')) {
    return (
      <Tooltip
        actionContent={
          <Tag bgColor={'red'} color={colors.red}>
            {t('statusTag.error')}
          </Tag>
        }
      >
        <Text>{t('statusTag.insufficientAmount')}</Text>
      </Tooltip>
    )
  }
  if (value.includes('value_lte_zero')) {
    return (
      <Tooltip
        actionContent={
          <Tag bgColor={'red'} color={colors.red}>
            {t('statusTag.error')}
          </Tag>
        }
      >
        <Text>{t('statusTag.amountGreaterThanZero')}</Text>
      </Tooltip>
    )
  }
  if (value === 'pending') {
    return (
      <Tag bgColor={'gray'} color={'gray'}>
        {t('statusTag.pending')}
      </Tag>
    )
  }
  return (
    <Tooltip
      actionContent={
        <Tag bgColor={'red'} color={colors.red}>
          {t('statusTag.error')}
        </Tag>
      }
    >
      <Text>{t('statusTag.genericError')}</Text>
    </Tooltip>
  )
}

const StockTransactionStatusTag = ({ value }) => {
  const { t } = useTranslation('editStocks')
  return (
    <div style={{ height: '40px', alignContent: 'center' }}>
      <Content value={value} t={t} />
    </div>
  )
}

export default StockTransactionStatusTag
